// extracted by mini-css-extract-plugin
export default {"box_wrap":"style_box_wrap__j1U6E","left_box":"style_left_box__cI-V5","right_box":"style_right_box__TtC20"};